// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { FileKind } from "../../../../define/FileKind";
import { MansionKind } from "../../../../define/MansionKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import UserDataManage from "../../../model/UserDataManage";
import MansionsBuildLayer from "./MansionsBuildLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MansionsBuildItem extends BaseComponent {

    @property(cc.Button)
    btnUpgrade: cc.Button = null;
    
	@property({ type: cc.Label, displayName:'' })
	labelPriceHint: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelUpgradeHint: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelPrice: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelPeopleNum: cc.Label = null;

	@property({ type: cc.RichText, displayName:'' })
	labelHint: cc.RichText = null;

	@property({ type: cc.Node, displayName:'' })
	nodeNoOpen: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeOpen: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelTitle: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	itemIcon: cc.Sprite = null;


    private buildId: string = null;
    private _parent: MansionsBuildLayer = null;
    private csvInfo: any = null;

    private curPrice = 0;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.refreshUI();
    }

    refreshUI() {
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.MANSION_BUILD, this.buildId);
        let mansionBuildData = UserDataManage.instance.mansionDataManage.mansionBuildDataManage.mansionBuildData;

        let bOpen = false;
        let lv = 0;
        let buildData = mansionBuildData.lists.get(this.buildId);
        if (!buildData) {
            this.openBuild();
        }
        buildData = mansionBuildData.lists.get(this.buildId);
        if (buildData) {
            lv = buildData.lv;
            bOpen = true;
        }
        
        this.refreshIcon(buildData && buildData.lv >= 1);
        this.labelTitle.string = this.csvInfo.name;
        this.labelPriceHint.string = lv > 0 ? '装修价:' : '建造价:';
        this.labelUpgradeHint.string = lv > 0 ? '升级装修' : '建  造';

        if (bOpen) {
            this.nodeOpen.active = true;
            this.nodeNoOpen.active = false;

            let curCapacity = 0;
            let price = Number(this.csvInfo.init_price);
            let upgrade_price_factor = Number(this.csvInfo.upgrade_price_factor);
            this.curPrice = price = Math.floor(price * Math.pow(upgrade_price_factor, lv));

            if (lv > 0) {
                curCapacity = Number(this.csvInfo['volume_lv'+lv]);
                if (isNaN(curCapacity)) {
                    curCapacity = 0;
                }
            }
            this.labelPeopleNum.string = curCapacity + '人';
            this.labelPrice.string = data_control.getNumberFormat(price);

            let nextLv = this.csvInfo['volume_lv'+(lv+1)];
            if (!utilsModel.isValidNumberValue(nextLv)) {
                this.btnUpgrade.interactable = false;
                this.labelUpgradeHint.string = '已满级';
            }
            
        } else {
            this.nodeOpen.active = false;
            this.nodeNoOpen.active = true;

            this.labelHint.string = this.csvInfo.hint;
        }
    }

    refreshIcon(bGood: boolean) {
        this.itemIcon.node.active = false;

        let splits = utilsModel.splitLineFeed(this.csvInfo.icon);
        let path = 'res/build/' + (bGood ? splits[0] : splits[1]).trim();
        getOneBundleByInstant(BUNDLE_SMALL_NAME.mansionBundle).load(path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.itemIcon.node.active = true;
                    this.itemIcon.spriteFrame = imgs;
                }
            }
        );
    }

    openBuild() {
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let mansionData = mansionDataManage.mansionData;
        let wifeDataManage = mansionDataManage.wifeDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        let mansionBuildData = mansionDataManage.mansionBuildDataManage.mansionBuildData;
        let open_cond = this.csvInfo.open_cond;
        let bCanOpen = false;
        if (!utilsModel.isValidNumberValue(open_cond)) {
            bCanOpen = true;
        } else {
            let splits = open_cond.split(FileKind.ResParseType.SUB_ITEM);
            let BuildCondition = MansionKind.BuildCondition;
            switch(splits[0]) {
                case BuildCondition.BUILD_REACH_LEVEL: {
                    let buildId = splits[1];
                    let buildLv = Number(splits[2]);
                    let buildData = mansionBuildData.lists.get(buildId);
                    if (buildData && buildData.lv >= buildLv) {
                        bCanOpen = true;
                    }
                    break;
                }
                case BuildCondition.MANSION_VOLUME: {
                    let volume = Number(splits[1]);
                    if (mansionData.curCapacity >= volume) {
                        bCanOpen = true;
                    }
                    break;
                }
                case BuildCondition.OWN_WIFE: {
                    let wC =  Number(splits[1]);
                    let wifeCount = wifeDataManage.ownWifeCount();
                    if (wifeCount >= wC) {
                        bCanOpen = true;
                    }
                    break;
                } 
                case BuildCondition.OWN_CHILD: {
                    let cC =  Number(splits[1]);
                    let childCount = childDataManage.ownChildCount();
                    if (childCount >= cC) {
                        bCanOpen = true;
                    }
                    break;
                }
                case BuildCondition.MARRY_WIFE: {
                    let wifeId =  splits[1];
                    let wData = wifeDataManage.wifeData.lists.get(wifeId);
                    if (wData && wData.state == MansionKind.WifeState.WIFE) {
                        bCanOpen = true;
                    }
                    break;
                }
            }
        }
        
        if (bCanOpen) {
            mansionBuildData.createItem(this.buildId);
        }
    }

    setData(
        _parent: MansionsBuildLayer
        , buildId: string
    ) {
        this.buildId = buildId;
        this._parent = _parent;
        if (this.isInit()) {
            this.refreshUI();
        }
    }

    onClickUpgrade() {
        // 播放声音
        O1HD.getManagers().soundMgr.playSound("anNiu");
        
        if (O1HD.getServices().userSrv.getCoins() < this.curPrice) {
            O1HD.getModules().uiControlModule.showMessageBox('金额不足');
            return;
        }
        O1HD.getServices().userSrv.setCoins(-this.curPrice, true);

        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let mansionBuildData = mansionDataManage.mansionBuildDataManage.mansionBuildData;
        let buildData = mansionBuildData.lists.get(this.buildId);
        if (!buildData) {
            return;
        }
        let nextLv = this.csvInfo['volume_lv'+(buildData.lv+1)];
        if (!utilsModel.isValidNumberValue(nextLv)) {
            console.error(`已满级`);
            return;
        }

        let curCapacity = Number(this.csvInfo['volume_lv'+buildData.lv]);
        if (isNaN(curCapacity)) {
            curCapacity = 0;
        }
        let spaceC = Number(nextLv) - curCapacity;
        mansionDataManage.mansionData.curCapacity += spaceC;
        mansionDataManage.mansionData.saveLocalData();

        mansionDataManage.mansionDataDispose();

        buildData.lv ++;
        mansionBuildData.saveLocalData();
        this._parent.refreshList();
    }

    // update (dt) {}
}
